import { AddressBook, DeviceAddressBooks } from '@/types/address-book';

export type AddressBookDeviceGroup = {
  addressBook: AddressBook;
  devices: DeviceAddressBooks[];
};

/**
 * Group devices by the address book(s) they use. A device appears under every
 * book it has. When the whole unit shares a single book this collapses to one
 * group listing every device, which lets the UI show the book once instead of
 * repeating it per device.
 */
export const groupDevicesByAddressBook = (
  devices: DeviceAddressBooks[],
): AddressBookDeviceGroup[] => {
  const groups = new Map<string, AddressBookDeviceGroup>();
  for (const device of devices) {
    for (const book of device.addressBooks) {
      const existing = groups.get(book.addressBookId);
      if (existing) {
        existing.devices.push(device);
      } else {
        groups.set(book.addressBookId, {
          addressBook: book,
          devices: [device],
        });
      }
    }
  }
  return [...groups.values()];
};
